export default class Poller {
  pollerInstance;

  constructor() {
    this.pollerInstance = null;
  }

  refresh(callBack, interval) {
    // Make initial request
    callBack();
    // set poller
    this.pollerInstance = setInterval(callBack, interval);
  }

  stop() {
    return this.pollerInstance && clearInterval(this.pollerInstance);
  }

  start(callBack, interval) {
    if (this.pollerInstance) {
      clearInterval(this.pollerInstance);
    }
    this.refresh(callBack, interval);
  }
}
